import React, { Component } from 'react';
import { NitroSingleSelect, NitroLoading } from 'nitro-components';
import DisableCover from '@src/components/libs/disabled';

class AddNewRoles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      isLoading: false,
    };
  }

  componentWillMount = () => {
    const { allRoles } = this.props;
    if (allRoles) {
      this.formatListData(allRoles);
    }
  };

  componentWillReceiveProps(nextProps) {
    const { allRoles } = nextProps;
    if (allRoles) {
      this.formatListData(allRoles);
    }
  }

  setLoading = status => {
    this.setState({
      isLoading: status,
    });
  };

  formatListData = allRoles => {
    if (allRoles && allRoles.length > 0) {
      const listitems = allRoles.map(r => ({
        label: `${r.name}   :   ${r.description}`,
        value: r.id,
        role: r,
      }));

      this.setState({
        options: listitems,
        isLoading: false,
      });
    }
  };

  handleSingleSelectChange = role => {
    this.props.action(role.role);
  };

  render() {
    const { isLoading } = this.state;

    return (
      <div>
        {isLoading && (
          <div>
            <DisableCover />
            <NitroLoading center screen />
          </div>
        )}
        <NitroSingleSelect
          placeholder="Select Roles"
          options={this.state.options}
          action={val => this.handleSingleSelectChange(val)}
        />
      </div>
    );
  }
}

export default AddNewRoles;



// WEBPACK FOOTER //
// ./src/features/admin/components/roles/AddNewRoles.js